/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `FormLayout*`'s.
 */
export type FormLayout = FormLayoutHorizontal | FormLayoutVertical;

/**
 * The Form horizontal layout type.
 */
export type FormLayoutHorizontal = typeof FORM_LAYOUT_HORIZONTAL;

/**
 * The Form vertical layout type.
 */
export type FormLayoutVertical = typeof FORM_LAYOUT_VERTICAL;

/**
 * The Form horizontal layout constant.
 */
export const FORM_LAYOUT_HORIZONTAL = `horizontal`;

/**
 * The Form vertical layout constant.
 */
export const FORM_LAYOUT_VERTICAL = `vertical`;
